import React, { useState, useEffect, useRef } from "react";
import Avatar from '@material-ui/core/Avatar';
import Resizer from 'react-image-file-resizer';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { Button, IconButton } from "@mui/material";


const STR_DEFAULT = "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"

export default function AvatarUploadImage(props) {
    const { image, editable, handleSendImage } = props;

    const fileInputRef = useRef(null);
    const [ imgBase64, setImgBase64] = useState(STR_DEFAULT);

    useEffect(() => {
        if (image===''){
            setImgBase64(STR_DEFAULT)
        }else{
            setImgBase64(image)
        }
    }, [image]);

    async function onChangeImg(e){
        // console.log("file uploaded: ", e.target.files[0]);
        const file = e.target.files[0];
        // console.log("🚀 ~ file: TeamHome.js:66 ~ TeamHome ~ file:", file)


        if (file) {
            try {
                const resizedImage = await new Promise((resolve) => {
                  Resizer.imageFileResizer(
                    file,
                    150, // Nuevo ancho deseado
                    150, // Nuevo alto deseado
                    'JPEG',
                    80, // Calidad de compresión (ajustable)
                    0,  // Forzar aspect ratio 1:1
                    (uri) => {resolve(uri);},
                    'base64' // Codificar como base64
                  );
                });
          
                // console.log('BASE64 (JPEG)');
                // console.log(resizedImage);

                // const imgSTRBASE64 = resizedImage.substring("data:image/jpeg;base64,".length);
                // console.log('BASE64 (JPEG)');
                // console.log(imgSTRBASE64);

                const img_input = resizedImage.substring("data:image/jpeg;base64,".length)
                setImgBase64(img_input)
                handleSendImage(img_input)
          
                // Ahora puedes almacenar resizedImage en tu base de datos o realizar otras operaciones.
            } catch (error) {
                console.error('Error al redimensionar la imagen', error);
            }
        }
    };


    return (
        <div className="sig_Profile_Avatar">

            <Avatar alt="User profile picture" src={`data:image/jpeg;base64,${imgBase64}`} className="sig_Profile_circular_img" />
            {editable === true ?
                <IconButton style={{margin: '-10px', width: '15px', height: '15px',position: 'relative',top: '140px', right: '30px'}} onClick={() => fileInputRef.current.click()}><AddAPhotoIcon color='success' fontSize="medium"/></IconButton>
                : <></>
            }

            <input
                type="file"
                accept="image/*"
                onChange={onChangeImg}
                style={{ display: 'none' }}
                ref={fileInputRef}
            />
        </div>
    )

}